var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 35C8.62635 35 1 27.3737 1 18C1 8.62635 8.62635 1 18 1C27.3737 1 35 8.62635 35 18C35 27.3737 27.3737 35 18 35ZM18 2.47826C9.44087 2.47826 2.47826 9.44087 2.47826 18C2.47826 26.5591 9.44087 33.5217 18 33.5217C26.5591 33.5217 33.5217 26.5591 33.5217 18C33.5217 9.44087 26.5591 2.47826 18 2.47826Z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6521 18.739H11.3478C10.9398 18.739 10.6086 18.4079 10.6086 17.9999C10.6086 17.5919 10.9398 17.2607 11.3478 17.2607H24.6521C25.0586 17.2607 25.3913 17.5919 25.3913 17.9999C25.3913 18.4079 25.0586 18.739 24.6521 18.739Z",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 25.3915C17.5921 25.3915 17.261 25.0589 17.261 24.6524V11.348C17.261 10.94 17.5921 10.6089 18.0001 10.6089C18.4081 10.6089 18.7392 10.94 18.7392 11.348V24.6524C18.7392 25.0589 18.4081 25.3915 18.0001 25.3915Z",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.54ef8034.svg";
export { ForwardRef as ReactComponent };